import ExternalLink from 'components/ExternalLink/ExternalLink'
import { getExplorerUrl } from 'config/chains'
import { helperToast } from 'rfx/lib/helperToast'
import { id } from 'utils/ethersImport'
const notifications: { [id: string]: boolean } = {}

export function pushSuccessNotification(
  chainId: number,
  message: string,
  e: { transactionHash: string },
) {
  const { transactionHash } = e

  const _id = id(message + transactionHash)
  if (notifications[_id]) {
    return
  }

  notifications[_id] = true

  const txUrl = getExplorerUrl(chainId) + 'tx/' + transactionHash
  helperToast.success(
    <div className="flex flex-col gap-1 text-xs font-semibold fhd:text-sm">
      <span>{message}</span>
      <ExternalLink className="text-th-active" href={txUrl}>
        View
      </ExternalLink>
    </div>,
  )
}

export function pushErrorNotification(
  chainId: number,
  message: string,
  e: { transactionHash: string },
) {
  const { transactionHash } = e
  const _id = id(message + transactionHash)
  if (notifications[_id]) {
    return
  }

  notifications[_id] = true

  const txUrl = getExplorerUrl(chainId) + 'tx/' + transactionHash
  helperToast.error(
    <div>
      {message} <ExternalLink href={txUrl}>View</ExternalLink>
    </div>,
  )
}
